var SearchFiltersDataTestId = /* @__PURE__ */ ((SearchFiltersDataTestId2) => {
  SearchFiltersDataTestId2["SEARCH_FILTERS_TRIGGER"] = "search-filters--trigger";
  SearchFiltersDataTestId2["SEARCH_FILTERS_MODAL"] = "search-filters--modal";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DISTANCE_SLIDER"] = "search-filters--distance-slider";
  SearchFiltersDataTestId2["SEARCH_FILTERS_AGE_GROUP"] = "search-filters--age-group";
  SearchFiltersDataTestId2["SEARCH_FILTERS_AGE_GROUP_OPTION"] = "search-filters--age-group-option";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DAY_TIME"] = "search-filters--day-time";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DAY_TIME_OPTION"] = "search-filters--day-time-option";
  SearchFiltersDataTestId2["SEARCH_FILTERS_PROFESSIONAL_GENDER"] = "search-filters--professional-gender";
  SearchFiltersDataTestId2["SEARCH_FILTERS_PROFESSIONAL_GENDER_OPTION"] = "search-filters--professional-gender-option";
  SearchFiltersDataTestId2["SEARCH_FILTERS_BOOKING_PREFERENCES"] = "search-filters--booking-preferences";
  SearchFiltersDataTestId2["SEARCH_FILTERS_BOOKING_PREFERENCE_OPTION"] = "search-filters--booking-preference-option";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DATE"] = "search-filters--date";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DATE_START"] = "search-filters--date-start";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DATE_END"] = "search-filters--date-end";
  SearchFiltersDataTestId2["SEARCH_FILTERS_DATE_RANGE_TOGGLE"] = "search-filters--date-range-toggle";
  SearchFiltersDataTestId2["SEARCH_FILTERS_CLEAR"] = "search-filters--clear";
  SearchFiltersDataTestId2["SEARCH_FILTERS_APPLY"] = "search-filters--apply";
  SearchFiltersDataTestId2["SEARCH_FILTERS_FOOTER_LOADING"] = "search-filters--footer-loading";
  return SearchFiltersDataTestId2;
})(SearchFiltersDataTestId || {});
export {
  SearchFiltersDataTestId
};
